export const environment = {
  production: true,
  buildId: '3670722018123011',
  configFile: 'config.json',
};
